<template>
<div>
<div class="container container--narrow pdt-30">
		<question-tag
			:correctRate="question.correctRate"
			:avgSolveTime="question.avgSolveTime"
			:level="paperLevel"
		></question-tag>
<div v-if="groupQuestionCount === 1">
		<div class="mgt-16 t-subtitle6 t-line-h-28 font-rn">
			<vue-mathjax :formula="question.contents.text" v-if="question.useMathjax"></vue-mathjax>
			<div v-else>
				{{ question.contents.text }}
			</div>
		</div>
		<div class="mgt-24" v-if="question && question.contents && question.contents.image">
			<img :src="question.contents.image" alt="" class="b-radius4 ">
		</div>
		<div class="mgt-24">
			<div class="b-radius4  pdl-24 pdr-24 mgb-8 box-54"
					v-for="(choice, index) in question.choices" :key="index"
					:class="[choice.correct === true ? 'bg-contentBlue': choice.correct === false && choice.selected === true ? 'bg-contentRed': 'bg-quizGray', choice.correct === true ? 'pdt-10 pdb-10': choice.correct === false && choice.selected === true ? 'pdt-10 pdb-10':'pdt-13 pdb-12']">
					<div class="d-flex align-items-center">
						<i class="material-icons t-color-white t-headline4 mgr-16 mgl--6" v-if="choice.correct === true">radio_button_unchecked</i>
						<i class="material-icons t-color-white t-headline4 mgr-16 mgl--6" v-if="choice.correct === false && choice.selected === true">close</i>
						<div class="q-count t-body1 l-spacing48 font-rn t-color-quizBlack" v-if="choice.correct === false && choice.selected === false">{{index+1}}</div>
						<div class="t-body1 font-r flex-grow-1 font-r mgl-4"
								:class="choice.correct === true ? 't-color-white': choice.correct === false && choice.selected === true ? 't-color-white': 't-color-quizBlack'">
							<vue-mathjax :formula="choice.contents" v-if="question.useMathjax"></vue-mathjax>
							<div v-else>
								{{ choice.contents }}
							</div>
						</div>
						<div class="t-headline9 " :class="choice.correct === false && choice.selected === false ? 't-color-quizBlack' : 't-color-whiteMedium'" v-if="choice.selectionRatio">{{parseInt(choice.selectionRatio)}}%</div>
					</div>
						<div class="mgt-24" v-if="choice.image">
							<img :src="choice.image" alt="" class="icon229">
						</div>
			</div>
		</div>
	</div>
				<div v-else>
					<div class="mgt-16 t-body1 t-line-h-28 ">
						{{groupQuestionTitle}}
					</div>
					<div class="mgt-24">
						<div class="mdc-card pda-24 bg-documentGray position-relative grouped-card">
							<div class="t-subtitle6 font-rn t-line-h-26 mgb-24">
								<vue-mathjax :formula="question.contents.text" v-if="question.useMathjax"></vue-mathjax>
								<div v-else>
									{{ question.contents.text }}
								</div>
							</div>
							<div class="mgt-24" v-if="question && question.contents && question.contents.image">
									<img :src="question.contents.image" alt="" class="b-radius4">
							</div>
							<div class="mgt-24">
								<div class="b-radius4  pdl-24 pdr-24 mgb-8 box-54"
										v-for="(choice, index) in question.choices" :key="index"
										:class="[choice.correct === true ? 'bg-contentBlue': choice.correct === false && choice.selected === true ? 'bg-contentRed': 'bg-quizGray', choice.correct === true ? 'pdt-10 pdb-10': 'pdt-13 pdb-12']">
										<div class="d-flex align-items-center">
											<i class="material-icons t-color-white t-headline4 mgr-16 mgl--6" v-if="choice.correct === true">radio_button_unchecked</i>
											<i class="material-icons t-color-white t-headline4 mgr-16 mgl--6" v-if="choice.correct === false && choice.selected === true">close</i>
											<div class="q-count t-body1 l-spacing48 font-rn t-color-quizBlack" v-if="choice.correct === false && choice.selected === false">{{index+1}}</div>
											<div class="t-body1 font-r flex-grow-1 font-r"
													:class="choice.correct === true ? 't-color-white': choice.correct === false && choice.selected === true ? 't-color-white': 't-color-quizBlack'">
												<vue-mathjax :formula="choice.contents" v-if="question.useMathjax"></vue-mathjax>
												<div v-else>
													{{ choice.contents }}
												</div>
											</div>
											<div class="t-headline9 " :class="choice.correct === false && choice.selected === false ? 't-color-quizBlack' : 't-color-whiteMedium'" v-if="choice.selectionRatio">{{parseInt(choice.selectionRatio)}}%</div>
										</div>
											<div class="mgt-24" v-if="choice.image">
												<img :src="choice.image" alt="" class="icon229">
											</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			<question-tip v-if="question.tip" :tip="question.tip" :marginType="groupQuestionCount === 1 ? true :false"/>
		</div>
		<question-feedback
			:commonFeedback="question.feedback.common"
			:correctFeedback="question.feedback.correct"
			:incorrectFeedback="question.feedback.incorrect"
			:videoFeedback="question.feedback.video"
			:feedbackStatus="feedback"
			:correct="question.correct"
			:questionId="question.questionId"
			:currentGroupIndex="currentGroupIndex"
></question-feedback>
</div>
</template>

<script>
/**
 * 단일답안 문항 피드백 컴포넌트(choice single type question  feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import QuestionFeedback from './QuestionFeedback.vue'
import {questionMixin} from '@/mixins/question.js'

export default {
	props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'paperLevel', 'feedback', 'currentGroupIndex'],
	data() {
		return {
		}
	},
	components: {
		'question-tag': QuestionTag,
		'question-tip': QuestionTip,
		'question-feedback': QuestionFeedback
	},

	mixins: [questionMixin],
}
</script>
<style scoped>
.question-choices .choice .correct-icon {
	min-width: 32px;
	height: 32px;}
</style>
